import { Injectable } from '@angular/core';
import { PpHttpOptions, PpHttpService } from '@penpencil/common';
import { environment } from 'environments/environment';
import {
    BehaviorSubject,
    catchError,
    debounceTime,
    map,
    Observable,
    retry,
} from 'rxjs';

import { handleError } from '../error-handler/error-handler.service';
import { StorageService } from '../storage/storage.service';

@Injectable({
    providedIn: 'root',
})
export class AuthService {
    _authenticated = new BehaviorSubject<boolean>(false);

    constructor(
        private apiService: PpHttpService,
        private storageService: StorageService
    ) {
        if (
            storageService.getUser() &&
            storageService.getUserToken() &&
            storageService.getExpiryDate()
        ) {
            this._authenticated.next(true);
        } else {
            this._authenticated.next(false);
        }
    }

    self(query?: any) {
        const options: PpHttpOptions = {
            apiPath: 'v1/users/self',
        };
        return this.apiService
            .get<any>(options)
            .pipe(retry(0), debounceTime(1000), catchError(handleError));
    }

    googleAuthSignIn(data: any): Observable<any> {
        const options: PpHttpOptions = {
            apiPath: 'v3/oauth/social-connect',
        };

        return this.apiService.post(data, options).pipe(
            catchError(handleError),
            map((res: any) => res['data'])
        );
    }

    signOut(): void {
        // Remove the access token from the local storage
        this.storageService.removeUser();
        this.storageService.removeUserToken();
        this.storageService.removeExpiryDate();
        // Set the authenticated flag to false
        this._authenticated.next(false);
    }

    login(user: any) {
        const loginDetails: any = {
            username: user.mobile,
            password: user.password,
            client_id: 'system-admin',
            client_secret: 'KjPXuAVfC5xbmgreETNMaL7z',
            grant_type: 'password',
            organizationId: environment.pwOrgId,
        };

        const options: PpHttpOptions = {
            apiPath: 'v1/oauth/token',
        };
        return this.apiService.post<any>(loginDetails, options).pipe(
            debounceTime(1000),
            catchError(handleError),
            map((res: any) => res['data'])
        );
    }
}
